/** @jsx jsx */
import React, { useState } from "react";
import { BgImage } from "gbimage-bridge";
import { graphql } from "gatsby";
import { jsx, Container, Heading, Box } from "theme-ui";
import ThemeContainer from "../../shared/ThemeContainer";
import "./faqsection.css";
import Accordion from "./Accordion";

export const query = graphql`
  fragment ContentfulFaqCollectionFragment on ContentfulFaqCollection {
    heading
    backgroundImage {
      gatsbyImageData
      title
    }
    faqs {
      id
      question
      answer {
        __typename
        raw
      }
    }
  }
`;

const FaqCollection = ({ sectionContent }) => {

  const { theme, faqs, heading, backgroundImage } = sectionContent;
  const [clicked, setClicked] = useState("0");

  const handleToggle = (index) => {
    if (clicked === index) {
      return setClicked("0");
    }
    return setClicked(index);
  };

  return (
    <ThemeContainer {...theme} py={["20px", "64px"]} px={["18px", "40px"]}>
      <Container px={["0px", "16px"]} py={["0px", "16px"]} sx={{overflowY:'hidden', minHeight:'max-content'}}>
        {heading && (
          <Heading as="h3" variant="bold" className='faq-header'>
            {heading}
          </Heading>
        )}
        </Container>
            <BgImage image={backgroundImage?.gatsbyImageData} sx={{  width: "100%", height:'100%'}} >
        <Container>
          <Box sx={{ alignSelf: ["center"] }} mt={["30px"]}>
            <Box className="accordion-container">
              <ul className="accordion">
                {faqs?.map((faq, index) => (
                  <Accordion
                    key={faq.id}
                    faq={faq}
                    onToggle={() => handleToggle(index)}
                    active={clicked === index}
                  />
                ))}
              </ul>
            </Box>
          </Box>
      </Container>
            </BgImage>
    </ThemeContainer>
  );
};

export default FaqCollection;

